/**
 * Bug #501
 * @Author Anupama P
 * @Date 14 Jul 2021
 */

import { AndTable, Title, Text, Typography, Paragraph, Loader, Wrapper, NoResultFound } from 'components';
/** Bug#494
  *  @Author: Linda Susan Raju 
  *  @Date: 14 Jul 2021
  */
import style from './style/table.module.css'
/* End Bug#494 */


export default function Table({ columns, dataSource,className=null, pagination = null, title = null, subTitle = null, totalCount = 0, loading = false, ...props }) {
    /** Bug#494
     *  @Author: Linda Susan Raju 
     *  @Date: 16 Jul 2021
     */
    let locale = {
        emptyText: (
            <NoResultFound message={props.message!==undefined ? props.message :'No records found'} className={style.noResultFound} />
        )
    };
    /**End #Bug502 */

    return (
        <Wrapper>
            {loading ?
                <Loader />
                :
                <AndTable
                    className={`${style.tableBorder} ${className}`} /** Bug#494 @Author: Linda Susan Raju  @Date: 14 Jul 2021*/
                    columns={columns}
                    dataSource={dataSource}
                    pagination={pagination ? pagination : false}
                    tableLayout="fixed" {...props}
                    locale={locale}
                    title={() => title ?
                        <Typography>
                            <Title level={5}>{title} {totalCount !==0 &&<Text> ({totalCount})</Text>}</Title>
                            <Paragraph>
                                {subTitle}
                            </Paragraph>
                        </Typography> : null}
                     scroll={{ x: '900' }}  // Bug# 526 * @Author Akhil MC * @Date 08 August 2021    
                />}
        </Wrapper>
    )
}